<nav class="navbar navbar-expand navbar-light bg-light capitan-sub-nav pl-md-5">
<ul class="navbar-nav">
  <li class="nav-item">
    <a routerLink="./customers" routerLinkActive="active" class="nav-link" href="#">
      Customers
      <span *ngIf="inboxService.getInboxCounts() && (getCustomersInboxCount() > 0)">
        ({{ getCustomersInboxCount() }})
      </span>
    </a>
  </li>
  <li class="nav-item">
    <a routerLink="./memberships-and-passes" routerLinkActive="active" class="nav-link" href="#">
      Memberships &amp; Passes
      <span *ngIf="inboxService.getInboxCounts() && (getMembershipsAndPassesInboxCount() > 0)">
        ({{ getMembershipsAndPassesInboxCount() }})
      </span>
    </a>
  </li>
  <li class="nav-item">
    <a routerLink="./associations" routerLinkActive="active" class="nav-link" href="#">
      Associations
      <span *ngIf="inboxService.getInboxCounts() && (getAssociationsInboxCount() > 0)">
        ({{ getAssociationsInboxCount() }})
      </span>
    </a>
  </li>
  <li class="nav-item">
    <a routerLink="./custom" routerLinkActive="active" class="nav-link" href="#">
      Custom
      <span *ngIf="inboxService.getInboxCounts() && (inboxService.getInboxCounts().custom_inbox_items > 0)">
        ({{ inboxService.getInboxCounts().custom_inbox_items }})
      </span>
    </a>
  </li>
</ul>
</nav>

<router-outlet></router-outlet>
